module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/suns_plan_show_bg_03-de05349c4724d5f108ac88039f753ef6.jpg";